module.exports = __webpack_public_path__ + "assets/images/monkey-dad-banana_a9059662fe931547b1c30f3d611d536a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stages/stage-three/monkey-dad-banana.png
// module id = 305
// module chunks = 0